import OpenBoxSuccess from './OpenBoxSuccess';

export default OpenBoxSuccess;
